import { DevicesStore } from './../../../../@store/devices/devices.store';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { map, Observable, of, switchMap } from 'rxjs';

import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
  PowerLimitationTooltip,
  WallboxSessionCharging,
  WallboxStatus,
  WallboxSubstatus,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { SUFFIX } from '../../../../shared/common/units';
import { FeaturesDetailsOverlayTypeEnum } from '../../installation-overlay.model';
import { InstallationDetailsMappingService } from 'src/app/+installations/services/installation-details-mapping.service';

@Component({
  selector: 'app-wallbox-system',
  templateUrl: './wallbox-system.component.html',
  styleUrls: ['./wallbox-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WallboxSystemComponent implements OnInit {
  readonly SUFFIX = SUFFIX;
  readonly FeaturePropertyKey = FeaturePropertyKey;

  chargingPower$: Observable<Feature<IsNumberValueProperty, never>>;
  displayedStatus$: Observable<Feature<WallboxStatus, never>>;
  displayedSubstatus$: Observable<Feature<WallboxSubstatus, never>>;
  sessionCharging$: Observable<Feature<WallboxSessionCharging, never>>;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  chargingTranslationKey = '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING.';

  displayedStatusHeading: string;
  displayedStatusSubheading: string;
  powerLimitationLabel$: Observable<PowerLimitationTooltip[]>;
  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private installationDetailsMappingService: InstallationDetailsMappingService,
    private devicesStore: DevicesStore
  ) {}

  ngOnInit(): void {
    this.chargingPower$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.wallboxDisplayedPower
    );
    this.displayedStatus$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.wallboxDisplayedStatus
    );
    this.powerLimitationLabel$ = this.devicesStore.getAllWallboxDevicesWithMatchingBoilerSerial$.pipe(
      map((devices) => (devices.length ? devices[0].id : null)),
      switchMap((deviceId) =>
        deviceId ? this.installationDetailsMappingService.powerLimitationLabel(deviceId) : of(null)
      )
    );
    this.displayedSubstatus$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.wallboxDisplayedSubstatus
    );
    this.sessionCharging$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.wallboxSessionCharging
    );
  }
}
